import { render, staticRenderFns } from "./NoContentAviso.vue?vue&type=template&id=2431cb73&"
import script from "./NoContentAviso.vue?vue&type=script&lang=js&"
export * from "./NoContentAviso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports